import { render, staticRenderFns } from "./r-item-upgrade-rule-dialog.vue?vue&type=template&id=6e8ee0cd&scoped=true"
import script from "./r-item-upgrade-rule-dialog.vue?vue&type=script&lang=js"
export * from "./r-item-upgrade-rule-dialog.vue?vue&type=script&lang=js"
import style0 from "./r-item-upgrade-rule-dialog.vue?vue&type=style&index=0&id=6e8ee0cd&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8ee0cd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e8ee0cd')) {
      api.createRecord('6e8ee0cd', component.options)
    } else {
      api.reload('6e8ee0cd', component.options)
    }
    module.hot.accept("./r-item-upgrade-rule-dialog.vue?vue&type=template&id=6e8ee0cd&scoped=true", function () {
      api.rerender('6e8ee0cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/item/upgrade/r-item-upgrade-rule-dialog.vue"
export default component.exports